export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_07.e4f309a0.jpg";